import { render, staticRenderFns } from "./reply-to-me-comments.vue?vue&type=template&id=21a2edc2&scoped=true&lang=html&"
import script from "./reply-to-me-comments.vue?vue&type=script&lang=js&"
export * from "./reply-to-me-comments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a2edc2",
  null
  
)

export default component.exports